/**
 *
 * Mixin
 *
 */

import { VideoMixin } from './Video';
import { ExerciseMixin } from './Exercise';

export const VideoExerciseMixin = {
  name: 'VideoExerciseMixin',

  mixins: [VideoMixin, ExerciseMixin],

  props: {
    typeOfEditor: {
      type: String,
      default: () => 'EXERCISE_NOTE',
    },
  },

  computed: {
    c_isVideoCpnt() {
      return -1 !== this.typeOfEditor.indexOf('VIDEO');
    },

    c_isExerciseCpnt() {
      return -1 !== this.typeOfEditor.indexOf('EXERCISE');
    },

    c_isNeedReset() {
      if (this.c_isVideoCpnt) {
        if (!this.video || !this.video.bulletId) {
          return false;
        }
      } else {
        if (!this.c_Question || !this.c_Question.questionId) {
          return false;
        }
      }
      return true;
    },
  },

  watch: {
    c_bulletId() {
      this.reset();
    },

    c_QuestionId() {
      this.reset();
    },
  },

  methods: {
    //
    reset() {
      //
    },
  },

  created() {
    this.reset();
  },
};
